import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux';

import SelectForm from './SelectForm';
import Header from '../../../common/Header';
import Popup from '../../../common/Popup';
import PopupTrigger from '../../../common/PopupTrigger';

import { TYPE } from '../../../../constant';
import { useRequest } from '../../../../hooks';
import { ProgressLearningTebs, ProgressList } from '../common';
import { mathpidLogAPICall } from '../../../../redux/logData';
import { aiBarosamListSelAPI } from '../../../../api/progressLearningAPI';

function AiBarosem() {
  const { t } = useTranslation();

  const logDispatch = useDispatch();
  const [alertMsg, setAlertMsg] = useState('');
  const [listCall, list] = useRequest((data) => aiBarosamListSelAPI(data), true);

  useEffect(() => {
    console.log("***** 진도학습 - 바로셈 진도")

    logDispatch(mathpidLogAPICall({
      verbId: 'accessed',
      objectId: 'screen',
      screenVersion: 'screenCode',
      screenCode: 'scr_0001_0000',
    }));
  }, []);

  // AI바로셈 소주제 목록 조회
  const onSearch = (data) => {
    let msg = "";
    if (!data.brsStepCd) msg = "단계코드를 선택하세요.";
    else if (!data.brsEditionCd) msg = "호 코드를 선택하세요.";

    if (msg) {
      setAlertMsg(msg);
      return;
    }
    listCall(data);
    
  }

  const alertMsgInitial = () => setAlertMsg("");

  return (
    <React.Fragment>
      <Header
        title={t("LC_06_01.msg001")}
      />
      <div className="layout-def tab-wrap layout-sl layout-my bg_gray2">
        <ProgressLearningTebs />
        <div className="container h_auto">
          <div className="inner">
            <div className="tabCont active" id="tabCont1">
              <SelectForm
                onSearch={onSearch}
              />
              <ProgressList
                list={list}
                learningEntryType={TYPE.LEARNING_ENTRY.AIBRS}
                noMsg={t("LC_06_01.msg006")}
              />
            </div>
          </div>
        </div>
      </div>
      {
        alertMsg && (
          <PopupTrigger>
            <Popup buttonLabel={["확인"]}  onConfirm={alertMsgInitial}>
              <p className="lc-alert_txt m-fw-normal">
                {alertMsg}
              </p>
            </Popup>
          </PopupTrigger>
        )
      }
    </React.Fragment>
  );
}

export default AiBarosem;
